/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsEGameOrientation } from './FxIdDomainSettingsEGameOrientation';
import {
    instanceOfFxIdDomainSettingsEGameOrientation,
    FxIdDomainSettingsEGameOrientationFromJSON,
    FxIdDomainSettingsEGameOrientationFromJSONTyped,
    FxIdDomainSettingsEGameOrientationToJSON,
} from './FxIdDomainSettingsEGameOrientation';

/**
 * @type FxIdWebFeaturesPlayGameResponseMobileGameOrientation
 * Данное свойство устарело. Используйте GameOrientation.
 * @export
 */
export type FxIdWebFeaturesPlayGameResponseMobileGameOrientation = FxIdDomainSettingsEGameOrientation;

export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSON(json: any): FxIdWebFeaturesPlayGameResponseMobileGameOrientation {
    return FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponseMobileGameOrientation {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(json)) {
        return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseMobileGameOrientationToJSONTyped(value?: FxIdWebFeaturesPlayGameResponseMobileGameOrientation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsEGameOrientation(value)) {
        return FxIdDomainSettingsEGameOrientationToJSON(value as FxIdDomainSettingsEGameOrientation);
    }

    return {};
}

